import { HTMLProps } from 'react'

export type MdStrongProps = HTMLProps<HTMLElement>

export const MdStrong = ({ children, ...rest }: MdStrongProps) => {
  return <strong {...rest}>{children}</strong>
}
